import { createContext, type ReactNode } from 'react';

export type ToastTone = 'success' | 'error' | 'info' | 'warning';

export interface ToastOptions {
  tone?: ToastTone;
  title: ReactNode;
  description?: ReactNode;
  durationMs?: number;
}

export interface ToastItem extends ToastOptions {
  id: string;
  tone: ToastTone;
}

export interface ToastContextValue {
  notify: (toast: ToastOptions) => string;
  dismiss: (id: string) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);
